export default function StatTile({
  label,
  value,
  hint,
  tone = "neutral",
}: {
  label: string;
  value: string | number;
  hint?: string;
  tone?: "neutral" | "good" | "warn" | "bad";
}) {
  const toneClass = {
    neutral: "text-textPrimary",
    good: "text-success",
    warn: "text-warning",
    bad: "text-danger",
  }[tone];

  return (
    <div className="card p-5">
      <div className="section-label mb-2">{label}</div>
      <div className={`text-3xl font-extrabold leading-none ${toneClass}`}>
        {value}
      </div>
      {hint && <div className="text-xs text-textMuted mt-2">{hint}</div>}
    </div>
  );
}
